import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'

export const FETCH_SITE_LIST = 'dashboard/growth/FETCH_SITE_LIST'
export const SET_SITE_LIST = 'dashboard/growth/SET_SITE_LIST'
export const FETCH_LOCUS_LIST = 'dashboard/growth/FETCH_LOCUS_LIST'
export const SET_LOCUS_LIST = 'dashboard/growth/SET_LOCUS_LIST'
export const FETCH_CAGES_TABLE_DATA = 'dashboard/growth/FETCH_CAGES_TABLE_DATA'
export const SET_CAGES_TABLE_DATA = 'dashboard/growth/SET_CAGES_TABLE_DATA'
export const FETCH_DATA_BY_CAGE = 'dashboard/growth/FETCH_DATA_BY_CAGE'
export const SET_CAGE_DATA = 'dashboard/growth/SET_CAGE_DATA'
export const SET_ACTIVE_CAGE = 'dashboard/growth/SET_ACTIVE_CAGE'
export const RESET_STORE = 'dashboard/growth/RESET_STORE'

export const fetchSiteList = ActionHelper.createActionObj(FETCH_SITE_LIST)
export const fetchLocusList = ActionHelper.createActionObj(FETCH_LOCUS_LIST)
export const fetchCagesTableData = ActionHelper.createActionObj(
  FETCH_CAGES_TABLE_DATA,
)
export const fetchDataByCage = ActionHelper.createActionObj(FETCH_DATA_BY_CAGE)
export const setCageData = ActionHelper.createActionObj(SET_CAGE_DATA)
export const setActiveCage = ActionHelper.createActionObj(SET_ACTIVE_CAGE)
export const resetStore = ActionHelper.createActionObj(RESET_STORE)

const initialState = () =>
  fromJS({
    siteList: [],
    locusList: [],
    activeCage: null,
    tableData: {
      data: [],
      count: 0,
    },
    cageData: {
      containerName: '',
      count: {
        species: '',
        fishCount: 0,
        comparison: {
          current: 0,
          yesterday: 0,
        },
      },
      size: {
        weight: {
          avgWeight: 0,
          comparison: {
            current: 0,
            yesterday: 0,
          },
        },
        biomass: {
          totalCount: 0,
          comparison: {
            current: 0,
            yesterday: 0,
          },
        },
      },
      groups: [],
    },
  })

const dashboardGrowth = handleActions(
  {
    [SET_SITE_LIST]: (state, action) =>
      state.set('siteList', List(action.list)),
    [SET_LOCUS_LIST]: (state, action) =>
      state.set('locusList', List(action.list)),
    [SET_CAGES_TABLE_DATA]: (state, action) =>
      state.set('tableData', Map(action.tableData)),
    [SET_CAGE_DATA]: (state, action) =>
      state.set('cageData', Map(action.payload)),
    [SET_ACTIVE_CAGE]: (state, action) =>
      state.set('activeCage', action.payload),
    [RESET_STORE]: () => initialState(),
  },
  initialState(),
)

export default dashboardGrowth
